import React from 'react';
import { Box, Checkbox } from '@mui/material';
import { Check } from '@mui/icons-material';
import { SONOS_BLUE } from './sonosUiStyles';

const UNCHECKED = (
  <Box sx={{
    width: 22,
    height: 22,
    borderRadius: '50%',
    border: `2px solid ${SONOS_BLUE}`,
    boxSizing: 'border-box',
  }}
  />
);

const CHECKED = (
  <Box sx={{
    width: 22,
    height: 22,
    borderRadius: '50%',
    backgroundColor: SONOS_BLUE,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }}
  >
    <Check sx={{ fontSize: 15, color: '#fff' }} />
  </Box>
);

interface RoundSonosCheckboxProps {
  checked: boolean;
  disabled?: boolean;
  onChange: () => void;
}

const RoundSonosCheckbox: React.FC<RoundSonosCheckboxProps> = ({
  checked,
  disabled,
  onChange,
}) => (
  <Checkbox
    checked={checked}
    disabled={disabled}
    onChange={(e) => {
      e.stopPropagation();
      onChange();
    }}
    icon={UNCHECKED}
    checkedIcon={CHECKED}
    sx={{
      p: 0.25,
      '&:hover': { backgroundColor: 'transparent' },
    }}
  />
);

export default RoundSonosCheckbox;
